import { isAnyArray } from 'is-any-array';
/**
 * Checks if input is of type array
 *
 * @param input - input
 */
export function xCheck(input) {
    if (!isAnyArray(input)) {
        throw new TypeError('input must be an array');
    }
    if (input.length === 0) {
        throw new TypeError('input must not be empty');
    }
}
//# sourceMappingURL=xCheck.js.map